var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLkdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#0275B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.996 19.9965V19.9959H20V14.1278C20 11.2572 19.3818 9.04584 16.0245 9.04584C14.4105 9.04584 13.3274 9.93117 12.8852 10.7705H12.8385V9.31384H9.65527V19.9959H12.9699V14.7065C12.9699 13.3138 13.234 11.9672 14.9594 11.9672C16.6594 11.9672 16.6847 13.5565 16.6847 14.7959V19.9965H19.996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26465 9.31372H7.58329V19.9957H4.26465V9.31372Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91867 3.99652C4.85759 3.99652 3.99658 4.85719 3.99658 5.91786C3.99658 6.97853 4.85759 7.8572 5.91867 7.8572C6.97976 7.8572 7.84076 6.97853 7.84076 5.91786C7.8401 4.85719 6.97909 3.99652 5.91867 3.99652V3.99652Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkdIcon);
export default __webpack_public_path__ + "static/media/lkd-icon.3b5a144e6b6bbde73e7875937b63ee3b.svg";
export { ForwardRef as ReactComponent };